export default (element) => {
  const body = document.querySelector('body');
  const modal = element;
  const select = element.querySelector('select');

  const closeButton = element.querySelector(
    '[data-target="close-redirect-modal"]',
  );
  const openButtons = document.querySelectorAll(
    '[data-target="open-redirect-modal"]',
  );

  const submitButton = element.querySelector('[data-target="redirect-submit"]');
  const shopCountry = window.Shopify?.country;
  const shopLang = window.Shopify?.language;

  const form = element.querySelector('form');
  const countryCodeInput = element.querySelector('input[name="country_code"]');
  const countrySelectorFlag = element.querySelector(
    '[data-target="country-selector-flag"]',
  );

  submitButton.addEventListener('click', () => {
    setDismissedRedirectCookie()
    updateCountry();
  });

  element.addEventListener('click', (event) => {
    if (event.target === element) {
      handleModalDismiss();
    }
  });

  closeButton.addEventListener('click', () => {
    handleModalDismiss();
  });

  window.addEventListener('resize', () => {
    element.close();
  });

  select.addEventListener('change', (event) => {
    updateFlag(event.target.value);
  });

  openButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      handleModalOpen()
    })
  })

  const updateFlag = (newCountryId) => {
    if (countrySelectorFlag) {
      const countrySelectorFlagClasses = countrySelectorFlag.classList;
      const countryClass = Array.from(countrySelectorFlagClasses).filter(
        (classItem) => classItem.includes('bg-country-'),
      );
      countrySelectorFlag.classList.remove(countryClass[0]);
      countrySelectorFlag.classList.add(
        `bg-country-${newCountryId.toLowerCase()}`,
      );
    }
  };

  const updateSelectedCountry = (userCountry) => {
    const optionsArray = Array.from(select.options);
    const index = optionsArray.findIndex((o) => o.value === userCountry);

    if (typeof index === 'number') {
      select.selectedIndex = index;

      updateFlag(userCountry);
      return true;
    }
    return false;
  };

  const updateCountry = () => {
    countryCodeInput.value = select.options[select.selectedIndex].value;
    if (form) form.submit();
  };

  const handleModalDismiss = () => {
    body.classList.remove('overflow-hidden');
    element.close();
    setDismissedRedirectCookie();
  };

  const handleModalOpen = () => {
    body.classList.add('overflow-hidden');
    modal.showModal();
  }

  const init = () => {
    const dismissedRedirect = getCookie('dismissedRedirect');

    if (!dismissedRedirect) {
      window.addEventListener('load', checkDetectedCountry);
    }
  };

  const getCookie = (name) =>
    decodeURIComponent(
      document.cookie
        .split(';')
        .find((cookie) => cookie.trim().startsWith(`${name}=`))
        ?.split('=')[1] || '',
    ) || null;

  const setDismissedRedirectCookie = () => {
    const now = new Date();
    const expirationDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);

    // eslint-disable-next-line max-len
    document.cookie = `dismissedRedirect=true; expires=${expirationDate.toUTCString()}; path=/`;
  };

  const checkDetectedCountry = async () => {
    const response = await fetch(
      `${window.Shopify.routes.root}browsing_context_suggestions.json` +
        '?country[enabled]=true' +
        `&country[exclude]=${shopCountry}` +
        '&language[enabled]=true' +
        `&language[exclude]=${shopLang}`,
    );

    const returnedData = await response.json();
    const detectedCountryHandle = returnedData.detected_values.country.handle;

    const targetValue = detectedCountryHandle;

    const modalCondition = detectedCountryHandle !== 'US';

    const selectableCountry = updateSelectedCountry(targetValue);

    // If no redirect happened, but the conditions stay the same, then show the modal.
    if (modalCondition) {
      if (selectableCountry) {
        body.classList.add('overflow-hidden');

        modal.showModal();
      }
    }
  };

  init();
};
